import logClientEvent, {ClientEventData, LogStrategy} from "../common/_client-event-logging";

// noinspection JSUnusedGlobalSymbols
export default function (){
    $(document).on('change', 'input, select, textarea', function () {
        //survey-page-form
        const itemID = $(this).data('item-id');
        if (!itemID || $(this).hasClass('bootstrap-slider')) {
            // return if it doesn't have an item id or
            // if it's a slider since we save just the hidden input that the slider set on selection
            return
        }
        const TYPE_ITEM_INPUT = 20;
        //var inputValue = $(this).val();

        // Checkboxes problem: $(this).val() is always 1, therefore use this.checked
        //if ($(this).attr('type') == 'checkbox') {
        //    inputValue = this.checked ? '1' : '0';
        //}

        // Partial type, see https://www.typescriptlang.org/docs/handbook/utility-types.html#partialt
        const itemEvent: Partial<ClientEventData> = {
            'itemID': itemID
            // Don't log input value
            //'data': inputValue.substring(0, 12) // Minimize request size (later truncated to 10 chars on the server)
        };

        logClientEvent(TYPE_ITEM_INPUT, LogStrategy.update, itemEvent);
    });
}